import { render, staticRenderFns } from "./SelfServiceOpenExpenses.vue?vue&type=template&id=c347321a"
import script from "./SelfServiceOpenExpenses.vue?vue&type=script&lang=js"
export * from "./SelfServiceOpenExpenses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports